import { useProfile } from '@modules/profile/loader';

export function useAcceptTosRedirection(): string | null {
  const profile = useProfile();

  return !profile.areTosAccepted ? '/accept-tos' : null;
}
